var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.9993 5.66357C31.0094 5.66357 28.0364 6.83728 25.7556 9.11951L9.08933 25.7755C4.52491 30.3343 4.52491 37.6942 9.08933 42.253L25.7556 58.909C30.3172 63.4706 37.6815 63.4706 42.2431 58.909L58.9094 42.253C63.4738 37.6942 63.4738 30.3343 58.9094 25.7755L42.2431 9.11951C39.9623 6.83728 36.9893 5.66357 33.9993 5.66357ZM33.9993 11.3337C35.5369 11.3337 37.0801 11.9319 38.2546 13.1056L54.9208 29.7617C57.2668 32.1063 57.2668 35.9194 54.9208 38.2669L38.2546 54.9229C35.9085 57.2675 32.093 57.2675 29.7441 54.9229L13.0779 38.2669C10.7319 35.9223 10.7319 32.1091 13.0779 29.7617L29.7441 13.1056C30.9186 11.9319 32.4618 11.3337 33.9993 11.3337Z",
    fill: "#F07416",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8327 22.6666C36.8327 21.1018 35.5642 19.8333 33.9993 19.8333C32.4345 19.8333 31.166 21.1018 31.166 22.6666V36.8333C31.166 38.3981 32.4345 39.6666 33.9993 39.6666C35.5642 39.6666 36.8327 38.3981 36.8327 36.8333V22.6666ZM33.9993 48.1666C35.5642 48.1666 36.8327 46.8981 36.8327 45.3333C36.8327 43.7684 35.5642 42.4999 33.9993 42.4999C32.4345 42.4999 31.166 43.7684 31.166 45.3333C31.166 46.8981 32.4345 48.1666 33.9993 48.1666Z",
    fill: "#F07416"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastWarningIcon);
export default __webpack_public_path__ + "static/media/ToastWarningIcon.f528ad78.svg";
export { ForwardRef as ReactComponent };